"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const FileRow_1 = __importDefault(require("./FileRow"));
const tech_1 = require("../../../tech");
const react_1 = require("react");
const react_ui_1 = require("@pasport/react-ui");
const PhotoItem = ({ photo, isEditMode, onDelete, strings, fetchFile }) => {
    const [showDeleteModal, setShowDeleteModal] = (0, react_1.useState)(false);
    const [isDeleting, setIsDeleting] = (0, react_1.useState)(false);
    const handleDelete = (e) => {
        if (!onDelete)
            return;
        setIsDeleting(true);
        onDelete(photo)
            .then(response => {
            setIsDeleting(false);
            setShowDeleteModal(false);
            return response;
        })
            .catch(() => {
            setIsDeleting(false);
            setShowDeleteModal(false);
        });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { className: "p-1 d-flex align-items-center", children: [(0, jsx_runtime_1.jsx)(FileRow_1.default, { file: photo, fetchFile: fetchFile }), isEditMode && ((0, jsx_runtime_1.jsx)("button", { className: "px-2 py-1 btn btn-danger", type: "button", onClick: () => setShowDeleteModal(true), children: (0, jsx_runtime_1.jsx)("i", { className: "bi bi-trash-fill fs-5" }) }))] }), onDelete && ((0, jsx_runtime_1.jsx)(react_ui_1.Modal, { show: showDeleteModal, onClose: () => setShowDeleteModal(false), children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: "fw-bold fs-5", children: strings.title }), (0, jsx_runtime_1.jsx)("div", { className: "mb-3", children: (0, tech_1.replaceJSX)(strings.subtitle, "{name}", (0, jsx_runtime_1.jsx)("strong", { children: photo.nazev })) }), (0, jsx_runtime_1.jsxs)("div", { className: "d-flex justify-content-end gap-3", children: [(0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-dark fw-bold", onClick: () => setShowDeleteModal(false), children: strings.cancelButton }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-danger fw-bold", onClick: handleDelete, disabled: isDeleting, children: isDeleting ? strings.deleting : strings.deleteButton })] })] }) }))] }));
};
exports.default = PhotoItem;
